import { Controller } from '@hotwired/stimulus';

// Mounts a Glide slider on the element and destroys it before Turbo caches
// the page, so snapshots keep pristine markup (no clones, no stale listeners).
export default class extends Controller {
  static values = { options: Object };

  connect() {
    this.teardown = this.teardown.bind(this);
    document.addEventListener('turbo:before-cache', this.teardown);
    whenGlideReady(() => this.mount());
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.teardown);
    this.teardown();
  }

  mount() {
    if (this.slider || !this.element.isConnected) return;

    this.slider = new Glide(this.element, this.optionsValue).mount();
  }

  teardown() {
    if (!this.slider) return;

    this.slider.destroy();
    this.slider = null;
  }
}

// Glide is loaded from a plain script tag; wait for it on first paint.
export function whenGlideReady(callback) {
  if (typeof Glide !== 'undefined') return callback();

  const script = document.querySelector('script[src*="glide.min.js"]');
  if (!script) return console.warn('Glide.js script not found');

  script.addEventListener('load', callback, { once: true });
}
